import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import ListPageHeader from "../../utilities/ListPageHeader";
import AgGridTable from "../../utilities/AgGridTable";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import AbOrderSuccess from "../create-order/AbOrderSuccess";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import { setSavedAbsData } from "app/store/absSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ViewPDF from "./ViewPDF";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
const handleDateFormat = (props) => {
  return props.value && moment(props.value).format('DD-MM-YYYY');
}
const handleDateFormatTime = (props) => {
  return props.value && moment(props.value).format('DD-MM-YYYY - HH:mm');
}
const AbsWithoutOrder = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderABFiles}`;
  const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const MOBILE_HIDDEN = [
  "commissionName", "wg1", "wg2", "total", "deliveryAddress",
  "factoryContact", "factoryContactPhone", "factoryContactEmail",
  "orderDate", "cutOffDate", "year",
];

  var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      var dateAsString = cellValue;
      //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
      const date = new Date(dateAsString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      if (formattedDate == null) return -1;
      var dateParts = formattedDate.split("/");
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    maxValidYear: new Date().getFullYear(),
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [error, setError] = useState("");
  const perPage = 10;
  const gridRef = useRef();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [addEnable, setAddEnable] = useState(true);
  const [openSuccessOrder, setOpenSuccessOrder] = useState(false);
  const [currentOrder, setCurrentOrder] = useState([]);
  const [open, setOpen] = useState(false);
  const [linkOrderStatus, setLinkOrderStatus] = useState(false);
  const [openDeleteAb, setOpenDeleteAb] = useState(false);
  const dispatch = useDispatch();
  const hasAbsData = useSelector(state => state.abs.hasAbsData);


  const ABAction = (props) => {
    const [rowValue, setRowValue] = useState(props.data.data);
    const [openPDF, setOpenPDF] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    const handleDeleteOrder = async () => {
      setOpenDelete(true);
    };

    const handleDeleteClose = () => {
      setOpenDelete(false);
    };
    const handleDeleteAb = async () => {
      try {
        let response = await OAuthService.deleteData(
          baseUrl + `api/orderABFiles`, rowValue.id
        );
        if (response.status === 200) {
          setSuccessMsg("AB file deleted successfully!");
          setSnackState(true);
          loadData();
        }
      } catch (error) {
        toast.error(
          "There was an error while deleting order. " +
          error?.response?.data?.errorMessage || error?.message
        );
      } finally {

        setOpenDelete(false)
      }
    };



    const handlePDFClose = () => {
      setOpenPDF(false);
    };
    const handleViewPDF = () => {
      setOpenPDF(true);
    };


    return (
      <>
        <div className="flex item-center justify-center">

          <Tooltip title={"PDF"}>
            <IconButton onClick={handleViewPDF}>
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:document-text
              </FuseSvgIcon>
            </IconButton>
          </Tooltip>
          {hasSOPRole &&
            <Tooltip title={"Delete"}>
              <IconButton onClick={handleDeleteOrder}>
                <FuseSvgIcon size={16} color="action">
                  heroicons-outline:trash
                </FuseSvgIcon>
              </IconButton>
            </Tooltip>
          }
        </div>

        <ViewPDF
          open={openPDF}
          abFiles={rowValue}
          handleClose={handlePDFClose}
          title={"View AB"}


        />
        <Dialog
          open={openDelete}
          fullWidth maxWidth="xs"
          onClose={handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete AB"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the AB file?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteClose} color = "secondary" variant="outlined">No</Button>
            <Button onClick={handleDeleteAb} color = "secondary" variant="outlined" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>


      </>
    );
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 60,
      maxWidth: 60,
      valueGetter: "node.rowIndex + 1",
      filter: false,
      resizable: true,
    },

    { field: "abNumber", enableRowGroup: true, minWidth: "50" },
    { field: "commissionName", enableRowGroup: true, minWidth: 200 },
    { field: "accountNo", enableRowGroup: true, minWidth: "50" },
    {
      field: "volume",
      enableRowGroup: true,
      minWidth: "50",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueFormatter: (params) => {
        return Number(params.value).toLocaleString(undefined, {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        });
      },
    },
    {
      field: "weight",
      enableRowGroup: true,
      minWidth: "50",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueFormatter: (params) => {
        return Number(params.value).toLocaleString(undefined, {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        });
      },
    },
    {
      field: "wg1",
      enableRowGroup: true,
      minWidth: "50",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueFormatter: (params) => {
        return Number(params.value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      field: "wg2",
      minWidth: "50",
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueFormatter: (params) => {
        return Number(params.value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      field: "total",
      enableRowGroup: true,
      minWidth: "50",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueFormatter: (params) => {
        return Number(params.value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      field: "loadingWeek",
      minWidth: "50",
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueGetter: (params) =>
        params?.data?.loadingWeek === 0 ? "On Hold" : params?.data?.loadingWeek,
    },
    {
      field: "year",
      minWidth: "50",
      enableRowGroup: true,
      valueGetter: (params) =>
        params?.data?.year === 0 ? "" : params?.data?.year,
    },
    {
      field: "deliveryDate",
      enableRowGroup: true,
      cellRenderer: handleDateFormat,
      filter: "agDateColumnFilter",
      filterParams,
    },
    {
      field: "cutOffDate",
      enableRowGroup: true,
      cellRenderer: handleDateFormat,
      filter: "agDateColumnFilter",
      filterParams,
    },
    {
      field: "orderDate",
      enableRowGroup: true,
      minWidth: "50",
      cellRenderer: handleDateFormat,
      filter: "agDateColumnFilter",
      filterParams,
    },
    // { field: "questionAndAnnotation", enableRowGroup: true },
    {
      field: "deliveryAddress",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
    },
    { field: "factoryContact", enableRowGroup: true },
    { field: "factoryContactPhone", enableRowGroup: true },
    { field: "factoryContactEmail", enableRowGroup: true },
    {
      field: "processedTime",
      headerName: "Received Time",
      minWidth: "50",
      filter: "agDateColumnFilter",
      filterParams,
      enableRowGroup: true,
      cellRenderer: handleDateFormatTime,
    },
    {
      headerName: "Actions",
      minWidth: 150,
      maxWidth: 150,
      resizable: false,
      sortable: false,
      filter: false,
      cellStyle: { overflow: "visible" },
      cellRenderer: (data) => <ABAction data={data} />,
    },
  ]);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "ABsWithoutOrder.xlsx",
      sheetName: "ABs without Order",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      let orderABs = list.data?._embedded?.orderABFiles;
      setRowData(orderABs);
      setSnackState(false);
    } catch (error) {
      setError(error.message);
    }
  };
  const onRowDoubleClicked = (params) => {
    var filename = selectedRows[0]?.id;
    navigate("/order/order-details/" + filename)
  };

  useEffect(() => {
    if (gridApi || linkOrderStatus) {
      loadData();
    }
  }, [gridApi, linkOrderStatus]);


  const onGridReady = (params) => {
    setGridApi(params.api);
    const colApi = params.columnApi ?? params.api; // v30 vs v31+
  colApi.setColumnsVisible
    ? colApi.setColumnsVisible(MOBILE_HIDDEN, !isMobile)
    : colApi.setColumnVisible && MOBILE_HIDDEN.forEach((c) => colApi.setColumnVisible(c, !isMobile));
  };
useEffect(() => {
  if (!gridApi) return;
  MOBILE_HIDDEN.forEach((c) => {
    (gridApi.setColumnsVisible ?? undefined)
      ? gridApi.setColumnsVisible([c], !isMobile)
      : gridRef.current?.columnApi?.setColumnVisible(c, !isMobile);
  });
}, [isMobile, gridApi]);
  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  }
  const handleAddButtonEnable = () => {
    const orderId = selectedRows.map(row => ({
      id: row.id,
    }));
    if (orderId.length > 0) {
      setCurrentOrder(selectedRows)
      dispatch(setSavedAbsData(selectedRows[0]))
      setOpen(true);
      setOpenSuccessOrder(true);

    }
  }
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const hasSOPRole = ["ROLE_SOPDIR", "ROLE_ORDERPRO", "ROLE_ADMIN", "ROLE_MD"].some((role) => token?.scope.includes(role));
  useEffect(() => {

    if (selectedRows.length == 1 && hasSOPRole) {
      setDeleteDisable(false);
      setAddEnable(false);
    } else {
      setDeleteDisable(true);
      setAddEnable(true);
    }
  }, [selectedRows, hasAbsData]);

  const orderHeaderAction = () => {
    return (
      <>
        <Tooltip title="Delete ABs ">
          <Button
            color="secondary"
            variant="contained"
            disabled={selectedRows.length === 0 ? true : false}
            onClick={() => setOpenDeleteAb(true)}
          >
            <DeleteForeverIcon />
          </Button>
        </Tooltip>
      </>
    );
  };
  
  const handleDeleteAbMultiple = async () => {
    try {
      const deletePromises = selectedRows.map((item) =>
        OAuthService.deleteData(baseUrl + `api/orderABFiles`, item.id)
      );

      await Promise.all(deletePromises);

      toast.success("AB files  deleted successfully");
      setSelectedRows([])
      loadData();
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    } finally {
      setOpenDeleteAb(false)
    }

  }

  return (
    <>
      <ListPageHeader
        componentName="ABs without Order"
        onBtExport={onBtExport}
        // handlePurge={handlePurge}
        // addPageLink="/addAbsWithoutOrder"
        pageName="ABs without Order"
        error={error}
        deleteDisable={deleteDisable}
        successMsg={successMsg}
        gridRef={gridRef}
        snackState={snackState}
        addEnable={addEnable}
        handleAddButtonEnable={handleAddButtonEnable}
        orderHeaderAction={orderHeaderAction()}
      />
      <div
        style={{
          height: isMobile ? "calc(100vh - 230px)" : "calc(100vh - 200px)",
          minHeight: 400,
          width: "100%",
        }}
        className={`${
          theme.palette.mode === "dark"
            ? "ag-theme-alpine-dark"
            : "ag-theme-alpine"
        }`}
      >
        <AgGridTable
          columnDefs={columnDefs}
          rowData={rowData}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          gridRef={gridRef}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={"absWithoutOrder"}
        />
      </div>
      <Dialog
        open={openDeleteAb}
        fullWidth maxWidth="xs"
        onClose={() => setOpenDeleteAb(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete AB"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete the AB file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDeleteAb(false)}
            color="secondary"
            variant="outlined"
          >
            No
          </Button>
          <Button
            onClick={handleDeleteAbMultiple}
            color="secondary"
            variant="outlined"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <AbOrderSuccess
        open={open}
        setOpen={setOpen}
        currentOrder={currentOrder}
        setOpenSuccessOrder={setOpenSuccessOrder}
        setLinkOrderStatus={setLinkOrderStatus}
      />
    </>
  );
};

export default AbsWithoutOrder;
